import Env from '../../base/env';
import Component from 'gia/Component';
import Splide from '@splidejs/splide';
import gsap from 'gsap';
import easesCustom from '../../fx/CustomEases';
import { ScrollTrigger } from '../../vendor/gsap-bonus-umd/ScrollTrigger';
import { SplitText } from '../../vendor/gsap-bonus-umd/SplitText';
gsap.registerPlugin(ScrollTrigger,SplitText);

export default class Module extends Component
{
  mount() {
    this.DOM = {}
    this.DOM.view = this.element
    this.DOM.slideshow = this.DOM.view.querySelector('.js-slideshow')
    this.DOM.separator = this.DOM.view.querySelector('.fxSeparator')
    this.DOM.texts = this.DOM.view.querySelectorAll('.fxText')
    this.DOM.cache = this.DOM.view.querySelector('.fxCache')
    this.DOM.items = this.DOM.view.querySelectorAll('.js-item-all')
    //! FX
    this.FX = {}
    this.FX.items = []
    for(let item of this.DOM.items) {
      const fx = new SplitText(item, { type:'chars' })
      gsap.set(fx.chars, { y: 150 })
      this.FX.items.push(fx)
    }
    this.FX.chars = []
    for(let fx of this.FX.items) {
      for(let char of fx.chars) {
        this.FX.chars.push(char)
      }
    }
    //? Fns
    setTimeout(() => {
      this._fx()
    }, Env.timingDelayFx);
    this.makeSlideshow()

  }

  _fx()
  {
    this.animate()
    this.reveal()
  }

  animate()
  {
    this.animation = gsap.timeline({
      onStart:()=>{
        this.slideshow.Components.Autoplay.play();
        setTimeout(() => {
          this.slideshow.Components.Autoplay.pause();
        }, 100);
      },
      onComplete:()=>{
        for(let fx of this.FX.items) {
          // fx.revert()
        }
      }
    })

    this.animation
    .add([
      gsap.fromTo(
        this.DOM.separator,
        {
          scaleX:0,
          transformOrigin:'left top'
        },
        {
          scaleX:1,
          ease:easesCustom.quart,
          duration:.7
        }
      ),
      gsap.fromTo(
        this.DOM.texts,
        {
          autoAlpha:0,
          y:30
        },
        {
          autoAlpha:1,
          y:0,
          ease:easesCustom.cubic,
          duration:.7,
          stagger:.2
        }
      ),
    ])
    .add([
      gsap.fromTo(
        this.DOM.cache,
        {
          autoAlpha:1,
        },
        {
          autoAlpha:0,
          ease:easesCustom.cubic,
          duration:1.2,
          delay:.5

        }
      ),
      gsap.fromTo(
        this.FX.chars,
        {
          y:150
        },
        {
          y:0,
          ease:easesCustom.quart,
          duration:.8,
          stagger:.02
        }
      ),
    ])
    .add(()=>{
      this.slideshow.Components.Autoplay.play();
    })
  }

  makeSlideshow()
  {
    this.slideshow = new Splide(this.DOM.slideshow  , {
      arrows: false,
      autoplay:true,
      interval: 3000,
      padding:{ left:0, right:0 },
      pauseOnFocus:false,
      pauseOnHover:false,
      pagination:false,
      perPage:1,
      perMove:1,
      rewind:true,
      rewindByDrag:true,
      speed: 2000,
      type: 'fade',
    }).mount()
    this.slideshow.Components.Autoplay.pause()
  }

  reveal()
  {
    const offsetStart = (Env.mobileCSS)?'top 60%':'top 50%';
    this.st = ScrollTrigger.create({
      animation:this.animation,
      trigger:this.DOM.view,
      start:offsetStart
    })
  }

  unmount()
  {
    this.st.kill(true)
  }
}
